import { Button, Dialog, DialogContent, Box, Typography } from "@mui/material";

export default function DialogVerImg({ open, handleClose, selectedImage }) {
  return (
    <Dialog
      open={open}
      fullWidth
      maxWidth={"xl"}
      keepMounted
      onClose={handleClose}
      aria-labelledby="alert-dialog-slide-title"
      aria-describedby="alert-dialog-slide-description"
    >
      <DialogContent sx={{ p: 3 }}>
        <img
          src={`${process.env.PUBLIC_URL}/static/files/pmi/${selectedImage}`}
          alt="Imagen seleccionada"
          style={{ width: "100%", height: "100%", objectFit: "cover" }}
        />
        <Box sx={{ display: "flex", justifyContent: "center", mt: 2 }}>
          <Button variant="contained" color="error" onClick={handleClose}>
            Cerrar
          </Button>
        </Box>
      </DialogContent>
    </Dialog>
  );
}
